module.exports = __webpack_public_path__ + "28b67065/img/share-icon.0f8a11b4.svg";